export const environment = {
  production: false,
  // apiBaseUrl: 'https://ghipapiprod.reliancegeneral.co.in/api/v1/',
  apiBaseUrl: 'https://ghipapiprod.indusindinsurance.co.in/api/v1/',
  envName: 'production',
  cookieDomain: '',
  sentryIOUrl: '',
  mixpanelToken: '',
  siteVersion: '%VERSION%',
  loginToken: 'sieWMsDZ1BOamVf9BAdhkVlzoh4qGWQe',
  authority: 'https://login.indusindinsurance.co.in/',
  // authority: 'https://login.reliancegeneral.co.in/',
  scopes: 'openid profile GhipApi',
  redirectUri: 'https://gigcustomer.indusindinsurance.co.in/auth-callback/',
  post_logout_redirect_uri: 'https://gigcustomer.indusindinsurance.co.in',
  client: 'Ghip',
};
